// 棒グラフ（HTML・自己完結）。全行を集計する（detail/dashboard 向け）。
import { chartModel } from "./model.mjs";
import type { ChartSpec, Row } from "../types";

export function Chart({ spec, rows, color }: { spec?: ChartSpec; rows: Row[]; color: string }) {
  const { bars } = chartModel(spec, rows);
  if (!bars.length) return <div class="chart"><span class="ph">データなし</span></div>;
  return (
    <div class="chart">
      {bars.map((b) => (
        <div class="chart-row">
          <span class="chart-k">{b.k}</span>
          <span class="chart-bar" style={`width:${b.w}%;background:${color}`} />
          <span class="chart-v">{b.v}</span>
        </div>
      ))}
    </div>
  );
}
